import { ReactNode } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import NoSsr from '@material-ui/core/NoSsr';
import * as styles from './styles/styles.module.scss';

type Props = {
  checked: boolean;
  disabled?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  label: ReactNode;
  labelClassName?: string;
  name?: string;
};

const Checkbox: React.FC<Props> = ({ checked = false, disabled = false, labelClassName = undefined, handleChange, name = '', label }) => (
  <NoSsr fallback={<div className={styles.ssrSpacer} />}>
    <FormControlLabel
      classes={{ label: styles.label, root: labelClassName }}
      control={
        <MaterialCheckbox
          classes={{ root: styles.checkboxRoot, checked: styles.checked }}
          checked={checked}
          disableRipple
          disabled={disabled}
          onChange={handleChange}
          size="small"
          name={name}
        />
      }
      label={label}
    />
  </NoSsr>
);

export default Checkbox;
